var _rect, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCounterInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 8,
    fill: "#FFEEF1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1837_1097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 26.375H16.25V29.75H18.5V26.375ZM24.125 21.875H21.875V29.75H24.125V21.875ZM29.75 16.25L27.5 16.25V29.75H29.75V16.25ZM27.5 15.125C26.8787 15.125 26.375 15.6287 26.375 16.25V29.75C26.375 30.3713 26.8787 30.875 27.5 30.875H29.75C30.3713 30.875 30.875 30.3713 30.875 29.75V16.25C30.875 15.6287 30.3713 15.125 29.75 15.125H27.5ZM20.75 21.875C20.75 21.2537 21.2537 20.75 21.875 20.75H24.125C24.7463 20.75 25.25 21.2537 25.25 21.875V29.75C25.25 30.3713 24.7463 30.875 24.125 30.875H21.875C21.2537 30.875 20.75 30.3713 20.75 29.75V21.875ZM15.125 26.375C15.125 25.7537 15.6287 25.25 16.25 25.25H18.5C19.1213 25.25 19.625 25.7537 19.625 26.375V29.75C19.625 30.3713 19.1213 30.875 18.5 30.875H16.25C15.6287 30.875 15.125 30.3713 15.125 29.75V26.375Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1837_1097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 18,
    height: 18,
    fill: "#FF92AE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterInfoIcon);
export default __webpack_public_path__ + "static/media/counter_info_icon.c9b5fdbadee22585ba672b117ea4126b.svg";
export { ForwardRef as ReactComponent };